import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../../../components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "../../../components/ui/card";
import { FileText, Clock, ArrowRight } from "lucide-react";

const NewImport = () => {
  return (
    <div className="min-h-screen bg-gray-50">

      <main className="container mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center mb-8">
          <h2 className="text-3xl font-bold text-primary">Imports</h2>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          <Card className="hover:shadow-md transition-shadow">
            <CardHeader>
              <CardTitle className="flex items-center justify-between">
                <span>Importer des contacts</span>
                <FileText className="h-5 w-5 text-primary" />
              </CardTitle>
              <CardDescription>
                Importez vos contacts depuis un fichier CSV
              </CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-gray-500 mb-4">
                Formatez vos données et importez-les facilement dans le CRM avec notre assistant d&apos;importation.
              </p>
            </CardContent>
            <CardFooter>
              <Link to="/dashboard/csv-import" className="w-full">
                <Button className="w-full bg-primary hover:bg-opacity-90">
                  Commencer l&apos;import
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </Link>
            </CardFooter>
          </Card>

          <Card className="hover:shadow-md transition-shadow">
            <CardHeader>
              <CardTitle className="flex items-center justify-between">
                <span>Historique des imports</span>
                <Clock className="h-5 w-5 text-primary" />
              </CardTitle>
              <CardDescription>
                Consultez vos imports précédents
              </CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-gray-500 mb-4">
                Accédez à l&apos;historique de vos imports précédents, avec les statistiques détaillées et la possibilité de les gérer.
              </p>
            </CardContent>
            <CardFooter>
              <Link to="/dashboard/import-history" className="w-full">
                <Button variant="outline" className="w-full border-primary text-primary">
                  Voir l&apos;historique
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </Link>
            </CardFooter>
          </Card>
        </div>
      </main>
    </div>
  );
};

export default NewImport;
